module.exports = __webpack_public_path__ + "img/analytics.c3915fc6.svg";